<template>
  <WTable
    style="height: calc(70vh)"
    max-height="calc(70vh - 50px)"
    :columns="columns"
    :rows="rows"
    :isDisabled="isDisabled"
    :bordered="false"
    :withToggleColumnVisibilityMode="!isOneColMode"
    :line-numbers="!isOneColMode"
    :row-style-class="rowStyleClassFn"
    :search-options="{
      enabled: true,
      skipDiacritics: true,
      placeholder: `${$t('general.search')}`,
      externalQuery: searchQuery
    }"
    :pagination-options="{
      enabled: false, // isOneColMode // info: отключена из-за неовместимости с легаси
      remoteMode: true,
      mode: 'pages', // pages, records
      position: 'bottom',
      perPage: 10,
      perPageDropdownEnabled: true,
      perPageDropdown: [5, 10, 20, 40, 50],
      dropdownAllowAll: true,
      jumpFirstOrLast : true,
      firstLabel: $t('general.pagination.firstPage'),
      lastLabel: $t('general.pagination.lastPage'),
      nextLabel: $t('general.pagination.nextPage'),
      prevLabel: $t('general.pagination.prevPage'),
      rowsPerPageLabel: $t('general.pagination.rowsPerPage'),
      pageLabel: $t('general.pagination.page'),
      ofLabel: $t('general.pagination.of'),
      allLabel: $t('general.pagination.all')
    }"
    :isLoading.sync="isDataLoading"
    @update:columns="handleUpdateColumns"
    @on-row-click="handleRowClick"
    @on-page-change="handlePageChange"
    @on-per-page-change="handlePerPageChange"
    @on-sort-change="onSortChange"
  >

    <template v-slot:table-menu>
      <slot name="table-menu"></slot>
    </template>

    <template v-slot:table-row="props">
      <template v-if="props.column.field === 'redirectType'">
        <span v-if="props.row.redirectType === 'static'">
          {{ $t('GuestControl.redirectType.static')}}
        </span>
        <span v-else-if="props.row.redirectType === 'dynamic'">
          {{ $t('GuestControl.redirectType.dynamic')}}
        </span>
        <span v-else>-</span>
      </template>

      <template v-else>
        {{ props.formattedRow[props.column.field] ? props.formattedRow[props.column.field] : '-' }}
      </template>
    </template>
  </WTable>
</template>

<script>
/**
 * компонент - таблица redirects rules.
 * компонент локальный: используется только в GuestControl.vue
 * подробнее по настройкам и пропсам - см компонент WTable.vue
 * @component
*/

import {
  generateTableColumns,
  generateTableRows
} from './config';

export default {
  name: 'RedirectsRulesTable',
  components: {
  },
  props: {
    items: {
      type: Array,
      required: true
    },
    activeRowRedirectId: {
      type: String,
      default: ''
    },
    searchQuery: {
      type: String,
      default: ''
    },
    isDataLoading: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    isOneColMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isTableColumnHidden: {
        name: false,
        redirectType: false
      }
    };
  },
  watch: {
  },
  computed: {
    columns: {
      get() {
        return generateTableColumns({
          i18nInstance: this.$i18n,
          hiddenColumnRules: {
            name: this.isTableColumnHidden.name,
            redirectType: this.isTableColumnHidden.redirectType
          },
          additionalRules: {}
        });
      },
      set(updatedColumns) {
        // обновить таблицу, когда обновились данные в колонках
        // например, какую-то колонку скрыли/раскрыли
        updatedColumns.forEach(el => {
          this.isTableColumnHidden[el.field] = el.hidden;
        });
      }
    },
    rows() {
      return generateTableRows({
        redirectsData: this.items
      });
    }
  },
  methods: {
    handleUpdateColumns(columns) {
      this.columns = columns;
    },
    rowStyleClassFn(row) {
      const rowRedirectId = row.nativeData.id;

      const classesArr = [
        this.getActiveRowClass(rowRedirectId),
        this.geRedirectRowLoadingClass(rowRedirectId)
      ];

      return classesArr.join(' ');
    },
    getActiveRowClass(rowRedirectId) {
      return this.activeRowRedirectId === rowRedirectId && 'redirects-rules-table__active-row';
    },
    geRedirectRowLoadingClass(rowRedirectId) {
      const firewallOperations = this.$store.state.redirectOperations;

      const loadingRows = firewallOperations.filter(operation => operation.model_id === rowRedirectId);

      return loadingRows.length ? 'redirects-rules-table__loading' : '';
    },
    handleRowClick(event) {
      const redirectItemId = event.row.nativeData.id;
      this.$emit('on-row-click', redirectItemId);
    },
    handlePageChange(event) {
      this.$emit('on-page-change', event);
    },
    handlePerPageChange(event) {
      this.$emit('on-per-page-change', event);
    },
    onSortChange({ params, sortedTableRows }) {
      const sortedNativeDataTableRows = sortedTableRows.map(rowData => rowData.nativeData);

      this.$emit('on-sort-change', { params, sortedNativeDataTableRows });
    }
  },
  created() {
  },
  mounted() {
  }
};
</script>

<style lang="css" scoped>
</style>

<style lang="css">
.redirects-rules-table__active-row {
  background: color-mix(in srgb, var(--brand-success) 70%, transparent);
  color: var(--font-color-main);
}

.redirects-rules-table__active-row:hover {
  background: color-mix(in srgb, var(--brand-success) 70%, transparent) !important;
  color: var(--font-color-main) !important;
}

.redirects-rules-table__loading {
  background: color-mix(in srgb, var(--brand-warning) 70%, transparent);
  animation-name: blink;
  animation-timing-function: linear;
  animation-duration: 1s;
  animation-iteration-count: infinite;
}
</style>
